import React from "react";
import SampleView from "../views/SampleView";

interface Props {}

const SamplePage: React.FC<Props> = (props) => {
  return (
    <>
      <SampleView />
    </>
  );
};

export default SamplePage;
